// @flow
import type { OrderedMealsInput } from "mmb/records/mealsInput"
import type { Meals, Meal } from "../../../scenes/BookingMeals/services/mealTypes"

const mapperMeals = (meals: OrderedMealsInput): Meals => {
  if (!meals) return []
  return meals.map<Meal>(({ extra_id, id, automation_state, items }) => ({
    id,
    abid: extra_id,
    status: automation_state,
    items: items
      ? items.map(
          ({
            name,
            code,
            price: { amount, base, service, merchant, service_flat, currency },
            passenger_id,
            segment_code,
            image_url,
          }) => ({
            name,
            code,
            price: {
              amount: parseFloat(amount),
              base: parseFloat(base),
              service: parseFloat(service),
              merchant: parseFloat(merchant),
              serviceFlat: parseFloat(service_flat),
              currency,
            },
            paxId: passenger_id,
            segmentId: segment_code,
            imageUrl: image_url,
          }),
        )
      : [],
  }))
}

export default mapperMeals
